webpackJsonp([1],{

/***/ "21GA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2gs6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Npah":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kTH0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rcvj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "x35b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// CONCATENATED MODULE: ./src/components/Point.ts
var Point = /** @class */ (function () {
    function Point(x, y) {
        this.x = 0;
        this.y = 0;
        this.x = x;
        this.y = y;
    }
    Point.prototype.toString = function () {
        return [this.x, this.y].join(',');
    };
    Point.prototype.toArray = function () {
        return [this.x, this.y];
    };
    Point.prototype.add = function (p) {
        return new Point(this.x + p.x, this.y + p.y);
    };
    Point.prototype.subtract = function (p) {
        return new Point(this.x - p.x, this.y - p.y);
    };
    Point.prototype.abs = function () {
        return new Point(Math.abs(this.x), Math.abs(this.y));
    };
    Point.prototype.multiply = function (v) {
        this.x *= v;
        this.y *= v;
        return this;
    };
    return Point;
}());
/* harmony default export */ var components_Point = (Point);

// CONCATENATED MODULE: ./node_modules/ts-loader!./node_modules/tslint-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SpiralPath.vue


var PI2 = Math.PI * 2;
/* harmony default export */ var SpiralPath = (vue_esm["a" /* default */].extend({
    name: 'SpiralPath',
    data: function () {
        return {};
    },
    props: {
        pathId: { type: String, required: false },
        size: { type: Number, required: false, default: 100 },
        // pixel per rotation
        span: { type: Number, required: false, default: 10 },
        strokeWidth: { type: Number, required: false, default: 0 },
        stroke: { type: String, required: false, default: 'black' },
        // direction in-to-out
        startFromInner: { type: Boolean, required: false, default: false },
        // direction clockwise
        counterclockwise: { type: Boolean, required: false, default: false },
        initAngle: { type: Number, required: false, default: 0 },
        paddingOuter: { type: Number, required: false, default: 0 },
        paddingInner: { type: Number, required: false, default: 0 }
    },
    computed: {
        halfSize: function () {
            return this.size / 2;
        },
        translate: function () {
            return "translate(" + this.halfSize + " " + this.halfSize + ")";
        },
        style: function () {
            var dir = this.counterclockwise ? -1 : 1;
            return "transform: scale(1, " + dir + ") rotate(" + this.initAngle * dir + "deg)";
        },
        pathD: function () {
            var tStep = PI2 / 4;
            var rStep = this.span / PI2;
            var maxR = this.halfSize - this.paddingOuter;
            var minR = rStep + this.paddingInner;
            var pts = [];
            var radius;
            var t = 0;
            if (this.startFromInner) {
                radius = minR;
                while (radius <= maxR) {
                    pts.push(new components_Point(Math.cos(t) * radius, Math.sin(t) * radius));
                    t += tStep;
                    radius = minR + t * rStep;
                }
            }
            else {
                radius = maxR;
                while (radius >= minR) {
                    pts.push(new components_Point(Math.cos(t) * radius, Math.sin(t) * radius));
                    t += tStep;
                    radius = maxR - t * rStep;
                }
            }
            var arcToList = pts.map(function (pt, i, ary) {
                if (i <= 0)
                    return '';
                var prevPt = ary[i - 1];
                var arc = pt.subtract(prevPt).abs();
                return "A " + arc.toString() + " 0 0 1 " + pt.toString();
            });
            return "M " + pts[0].toArray().join(' ') + " " + arcToList.join(' ');
        }
    }
}));

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3430d79a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SpiralPath.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":_vm.size,"height":_vm.size}},[_c('g',{attrs:{"transform":_vm.translate}},[_c('path',{style:(_vm.style),attrs:{"id":_vm.pathId,"d":_vm.pathD,"stroke-width":_vm.strokeWidth,"stroke":_vm.stroke,"fill":"none"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_SpiralPath = (esExports);
// CONCATENATED MODULE: ./src/components/SpiralPath.vue
function injectStyle (ssrContext) {
  __webpack_require__("21GA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3430d79a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  SpiralPath,
  components_SpiralPath,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_SpiralPath = (Component.exports);

// CONCATENATED MODULE: ./node_modules/ts-loader!./node_modules/tslint-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SpiralText.vue


/* harmony default export */ var SpiralText = (vue_esm["a" /* default */].extend({
    name: 'SpiralText',
    components: {
        SpiralPath: src_components_SpiralPath
    },
    data: function () {
        return {
            pathIdPrefix: 'path'
        };
    },
    props: {
        size: { type: Number, required: false, default: 16 },
        fontSize: { type: Number, required: false, default: 12 },
        lineHeight: { type: Number, required: false, default: 1.0 },
        text: { type: String, required: false, default: '' },
        strokeWidth: { type: Number, required: false, default: 0 },
        inToOut: { ype: Boolean, required: false, default: false },
        counterclockwise: { ype: Boolean, required: false, default: false },
        startFromInner: { ype: Boolean, required: false, default: false },
        initAngle: { type: Number, required: false, default: 0 },
        paddingInner: { type: Number, required: false }
    },
    computed: {
        halfSize: function () {
            return this.size / 2;
        },
        translate: function () {
            return "translate(" + this.halfSize + " " + this.halfSize + ")";
        },
        paddingInnerComputed: function () {
            return this.paddingInner === undefined
                ? this.counterclockwise
                    ? this.fontSize
                    : 0
                : this.paddingInner;
        }
    }
}));

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45420d91","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SpiralText.vue
var SpiralText_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":_vm.size,"height":_vm.size}},[_c('spiral-path',{attrs:{"span":_vm.fontSize * _vm.lineHeight,"size":_vm.size,"stroke-width":0,"path-id":("" + _vm.pathIdPrefix + _vm._uid),"clip-outside":true,"clip-inside":true,"counterclockwise":_vm.counterclockwise,"init-angle":_vm.initAngle,"padding-outer":_vm.counterclockwise ? 0 : _vm.fontSize,"padding-inner":_vm.paddingInnerComputed,"start-from-inner":_vm.startFromInner}}),_vm._v(" "),_c('g',{attrs:{"transform":_vm.translate}},[_c('text',{attrs:{"font-size":_vm.fontSize}},[_c('textPath',{attrs:{"href":("#" + _vm.pathIdPrefix + _vm._uid)}},[_vm._v(_vm._s(_vm.text))])])])],1)}
var SpiralText_staticRenderFns = []
var SpiralText_esExports = { render: SpiralText_render, staticRenderFns: SpiralText_staticRenderFns }
/* harmony default export */ var components_SpiralText = (SpiralText_esExports);
// CONCATENATED MODULE: ./src/components/SpiralText.vue
function SpiralText_injectStyle (ssrContext) {
  __webpack_require__("rcvj")
}
var SpiralText_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var SpiralText___vue_template_functional__ = false
/* styles */
var SpiralText___vue_styles__ = SpiralText_injectStyle
/* scopeId */
var SpiralText___vue_scopeId__ = "data-v-45420d91"
/* moduleIdentifier (server only) */
var SpiralText___vue_module_identifier__ = null
var SpiralText_Component = SpiralText_normalizeComponent(
  SpiralText,
  components_SpiralText,
  SpiralText___vue_template_functional__,
  SpiralText___vue_styles__,
  SpiralText___vue_scopeId__,
  SpiralText___vue_module_identifier__
)

/* harmony default export */ var src_components_SpiralText = (SpiralText_Component.exports);

// CONCATENATED MODULE: ./node_modules/ts-loader!./node_modules/tslint-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/example/SpiralText.vue


/* harmony default export */ var example_SpiralText = (vue_esm["a" /* default */].extend({
    name: 'app',
    components: {
        SpiralText: src_components_SpiralText
    },
    data: function () {
        return {
            text: "\u543E\u8F29\u308F\u304C\u306F\u3044\u306F\u732B\u3067\u3042\u308B\u3002\u540D\u524D\u306F\u307E\u3060\u7121\u3044\u3002\n\u3069\u3053\u3067\u751F\u308C\u305F\u304B\u3068\u3093\u3068\u898B\u5F53\u3051\u3093\u3068\u3046\u304C\u3064\u304B\u306C\u3002\u4F55\u3067\u3082\u8584\u6697\u3044\u3058\u3081\u3058\u3081\u3057\u305F\u6240\u3067\u30CB\u30E3\u30FC\u30CB\u30E3\u30FC\u6CE3\u3044\u3066\u3044\u305F\u4E8B\u3060\u3051\u306F\u8A18\u61B6\u3057\u3066\u3044\u308B\u3002\u543E\u8F29\u306F\u3053\u3053\u3067\u59CB\u3081\u3066\u4EBA\u9593\u3068\u3044\u3046\u3082\u306E\u3092\u898B\u305F\u3002\u3057\u304B\u3082\u3042\u3068\u3067\u805E\u304F\u3068\u305D\u308C\u306F\u66F8\u751F\u3068\u3044\u3046\u4EBA\u9593\u4E2D\u3067\u4E00\u756A\u7370\u60AA\u3069\u3046\u3042\u304F\u306A\u7A2E\u65CF\u3067\u3042\u3063\u305F\u305D\u3046\u3060\u3002\u3053\u306E\u66F8\u751F\u3068\u3044\u3046\u306E\u306F\u6642\u3005\u6211\u3005\u3092\u6355\u3064\u304B\u307E\u3048\u3066\u716E\u306B\u3066\u98DF\u3046\u3068\u3044\u3046\u8A71\u3067\u3042\u308B\u3002\u3057\u304B\u3057\u305D\u306E\u5F53\u6642\u306F\u4F55\u3068\u3044\u3046\u8003\u3082\u306A\u304B\u3063\u305F\u304B\u3089\u5225\u6BB5\u6050\u3057\u3044\u3068\u3082\u601D\u308F\u306A\u304B\u3063\u305F\u3002\u305F\u3060\u5F7C\u306E\u638C\u3066\u306E\u3072\u3089\u306B\u8F09\u305B\u3089\u308C\u3066\u30B9\u30FC\u3068\u6301\u3061\u4E0A\u3052\u3089\u308C\u305F\u6642\u4F55\u3060\u304B\u30D5\u30EF\u30D5\u30EF\u3057\u305F\u611F\u3058\u304C\u3042\u3063\u305F\u3070\u304B\u308A\u3067\u3042\u308B\u3002\u638C\u306E\u4E0A\u3067\u5C11\u3057\u843D\u3061\u3064\u3044\u3066\u66F8\u751F\u306E\u9854\u3092\u898B\u305F\u306E\u304C\u3044\u308F\u3086\u308B\u4EBA\u9593\u3068\u3044\u3046\u3082\u306E\u306E\u898B\u59CB\u307F\u306F\u3058\u3081\u3067\u3042\u308D\u3046\u3002\u3053\u306E\u6642\u5999\u306A\u3082\u306E\u3060\u3068\u601D\u3063\u305F\u611F\u3058\u304C\u4ECA\u3067\u3082\u6B8B\u3063\u3066\u3044\u308B\u3002\u7B2C\u4E00\u6BDB\u3092\u3082\u3063\u3066\u88C5\u98FE\u3055\u308C\u3079\u304D\u306F\u305A\u306E\u9854\u304C\u3064\u308B\u3064\u308B\u3057\u3066\u307E\u308B\u3067\u85AC\u7F36\u3084\u304B\u3093\u3060\u3002\u305D\u306E\u5F8C\u3054\u732B\u306B\u3082\u3060\u3044\u3076\u9022\u3042\u3063\u305F\u304C\u3053\u3093\u306A\u7247\u8F2A\u304B\u305F\u308F\u306B\u306F\u4E00\u5EA6\u3082\u51FA\u4F1A\u3067\u304F\u308F\u3057\u305F\u4E8B\u304C\u306A\u3044\u3002\u306E\u307F\u306A\u3089\u305A\u9854\u306E\u771F\u4E2D\u304C\u3042\u307E\u308A\u306B\u7A81\u8D77\u3057\u3066\u3044\u308B\u3002\u305D\u3046\u3057\u3066\u305D\u306E\u7A74\u306E\u4E2D\u304B\u3089\u6642\u3005\u3077\u3046\u3077\u3046\u3068\u7159\u3051\u3080\u308A\u3092\u5439\u304F\u3002\u3069\u3046\u3082\u54BD\u3080\u305B\u307D\u304F\u3066\u5B9F\u306B\u5F31\u3063\u305F\u3002\u3053\u308C\u304C\u4EBA\u9593\u306E\u98F2\u3080\u7159\u8349\u305F\u3070\u3053\u3068\u3044\u3046\u3082\u306E\u3067\u3042\u308B\u4E8B\u306F\u3088\u3046\u3084\u304F\u3053\u306E\u9803\u77E5\u3063\u305F\u3002\n\u3053\u306E\u66F8\u751F\u306E\u638C\u306E\u88CF\u3046\u3061\u3067\u3057\u3070\u3089\u304F\u306F\u3088\u3044\u5FC3\u6301\u306B\u5750\u3063\u3066\u304A\u3063\u305F\u304C\u3001\u3057\u3070\u3089\u304F\u3059\u308B\u3068\u975E\u5E38\u306A\u901F\u529B\u3067\u904B\u8EE2\u3057\u59CB\u3081\u305F\u3002\u66F8\u751F\u304C\u52D5\u304F\u306E\u304B\u81EA\u5206\u3060\u3051\u304C\u52D5\u304F\u306E\u304B\u5206\u3089\u306A\u3044\u304C\u7121\u6697\u3080\u3084\u307F\u306B\u773C\u304C\u5EFB\u308B\u3002\u80F8\u304C\u60AA\u304F\u306A\u308B\u3002\u5230\u5E95\u3068\u3046\u3066\u3044\u52A9\u304B\u3089\u306A\u3044\u3068\u601D\u3063\u3066\u3044\u308B\u3068\u3001\u3069\u3055\u308A\u3068\u97F3\u304C\u3057\u3066\u773C\u304B\u3089\u706B\u304C\u51FA\u305F\u3002\u305D\u308C\u307E\u3067\u306F\u8A18\u61B6\u3057\u3066\u3044\u308B\u304C\u3042\u3068\u306F\u4F55\u306E\u4E8B\u3084\u3089\u3044\u304F\u3089\u8003\u3048\u51FA\u305D\u3046\u3068\u3057\u3066\u3082\u5206\u3089\u306A\u3044\u3002",
            fontSize: 20
        };
    }
}));

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e7c6a2c0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/example/SpiralText.vue
var example_SpiralText_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.fontSize),expression:"fontSize",modifiers:{"number":true}}],staticClass:"range",staticStyle:{"width":"100%"},attrs:{"type":"range","min":"12","max":"100","step":"any"},domProps:{"value":(_vm.fontSize)},on:{"__r":function($event){_vm.fontSize=_vm._n($event.target.value)},"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.text),expression:"text"}],domProps:{"value":(_vm.text)},on:{"input":function($event){if($event.target.composing){ return; }_vm.text=$event.target.value}}}),_vm._v(" "),_c('spiral-text',{staticStyle:{"background":"#9ff"},attrs:{"text":_vm.text,"font-size":_vm.fontSize,"size":400,"line-height":1.2}}),_vm._v(" "),_c('spiral-text',{staticStyle:{"background":"#ff9"},attrs:{"text":_vm.text,"font-size":_vm.fontSize,"size":400,"line-height":1.2,"counterclockwise":true,"start-from-inner":true,"padding-inner":80,"init-angle":135}})],1)}
var example_SpiralText_staticRenderFns = []
var example_SpiralText_esExports = { render: example_SpiralText_render, staticRenderFns: example_SpiralText_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_example_SpiralText = (example_SpiralText_esExports);
// CONCATENATED MODULE: ./src/example/SpiralText.vue
function example_SpiralText_injectStyle (ssrContext) {
  __webpack_require__("Npah")
}
var example_SpiralText_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var example_SpiralText___vue_template_functional__ = false
/* styles */
var example_SpiralText___vue_styles__ = example_SpiralText_injectStyle
/* scopeId */
var example_SpiralText___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var example_SpiralText___vue_module_identifier__ = null
var example_SpiralText_Component = example_SpiralText_normalizeComponent(
  example_SpiralText,
  selectortype_template_index_0_src_example_SpiralText,
  example_SpiralText___vue_template_functional__,
  example_SpiralText___vue_styles__,
  example_SpiralText___vue_scopeId__,
  example_SpiralText___vue_module_identifier__
)

/* harmony default export */ var src_example_SpiralText = (example_SpiralText_Component.exports);

// CONCATENATED MODULE: ./node_modules/ts-loader!./node_modules/tslint-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/example/SpiralPath.vue


/* harmony default export */ var example_SpiralPath = (vue_esm["a" /* default */].extend({
    name: 'app',
    components: {
        SpiralPath: src_components_SpiralPath
    },
    data: function () {
        return {
            span: 20,
            strokeWidth: 1,
            size: 200,
            initAngle: 0,
            startFromInner: false
        };
    }
}));

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9c0fe374","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/example/SpiralPath.vue
var SpiralPath_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.span),expression:"span",modifiers:{"number":true}}],staticClass:"range",staticStyle:{"width":"100%"},attrs:{"type":"range","min":"1","max":"100","step":"any"},domProps:{"value":(_vm.span)},on:{"__r":function($event){_vm.span=_vm._n($event.target.value)},"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.strokeWidth),expression:"strokeWidth",modifiers:{"number":true}}],staticClass:"range",staticStyle:{"width":"100%"},attrs:{"type":"range","min":"1","max":_vm.span,"step":"any"},domProps:{"value":(_vm.strokeWidth)},on:{"__r":function($event){_vm.strokeWidth=_vm._n($event.target.value)},"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.size),expression:"size",modifiers:{"number":true}}],staticClass:"range",staticStyle:{"width":"100%"},attrs:{"type":"range","min":"32","max":"500","step":"any"},domProps:{"value":(_vm.size)},on:{"__r":function($event){_vm.size=_vm._n($event.target.value)},"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.initAngle),expression:"initAngle",modifiers:{"number":true}}],staticClass:"range",staticStyle:{"width":"100%"},attrs:{"type":"range","min":"0","max":"360","step":"any"},domProps:{"value":(_vm.initAngle)},on:{"__r":function($event){_vm.initAngle=_vm._n($event.target.value)},"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.startFromInner),expression:"startFromInner"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.startFromInner)?_vm._i(_vm.startFromInner,null)>-1:(_vm.startFromInner)},on:{"change":function($event){var $$a=_vm.startFromInner,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.startFromInner=$$a.concat([$$v]))}else{$$i>-1&&(_vm.startFromInner=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.startFromInner=$$c}}}}),_vm._v(" "),_c('spiral-path',{staticStyle:{"background":"#000"},attrs:{"span":_vm.span,"size":_vm.size,"strokeWidth":_vm.strokeWidth,"init-angle":_vm.initAngle,"start-from-inner":_vm.startFromInner,"stroke":"#fff"}})],1)}
var SpiralPath_staticRenderFns = []
var SpiralPath_esExports = { render: SpiralPath_render, staticRenderFns: SpiralPath_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_example_SpiralPath = (SpiralPath_esExports);
// CONCATENATED MODULE: ./src/example/SpiralPath.vue
function SpiralPath_injectStyle (ssrContext) {
  __webpack_require__("kTH0")
}
var SpiralPath_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var SpiralPath___vue_template_functional__ = false
/* styles */
var SpiralPath___vue_styles__ = SpiralPath_injectStyle
/* scopeId */
var SpiralPath___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SpiralPath___vue_module_identifier__ = null
var SpiralPath_Component = SpiralPath_normalizeComponent(
  example_SpiralPath,
  selectortype_template_index_0_src_example_SpiralPath,
  SpiralPath___vue_template_functional__,
  SpiralPath___vue_styles__,
  SpiralPath___vue_scopeId__,
  SpiralPath___vue_module_identifier__
)

/* harmony default export */ var src_example_SpiralPath = (SpiralPath_Component.exports);

// CONCATENATED MODULE: ./node_modules/ts-loader!./node_modules/tslint-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue



/* harmony default export */ var App = (vue_esm["a" /* default */].extend({
    name: 'app',
    components: {
        SpiralText: src_example_SpiralText,
        SpiralPath: src_example_SpiralPath
    },
    data: function () {
        return {};
    }
}));

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06cdb03c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('spiral-path'),_vm._v(" "),_c('spiral-text')],1)}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("2gs6")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// CONCATENATED MODULE: ./src/main.ts
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.


vue_esm["a" /* default */].config.productionTip = false;
/* tslint:disable no-unused-expression */
new vue_esm["a" /* default */]({
    el: '#app',
    template: '<App/>',
    components: { App: src_App }
});


/***/ })

},["x35b"]);


// WEBPACK FOOTER //
// static/js/app.ede2166a42c345e6a605.js